import { render } from "./component-ge-expl-id-vg.vue?vue&type=template&id=e1751326"
import script from "./component-ge-expl-id-vg.vue?vue&type=script&setup=true&lang=js"
export * from "./component-ge-expl-id-vg.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/e-grid/eosrc-card/field-wrappers/component-ge-expl-id-vg.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e1751326"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e1751326', __exports__)) {
    api.reload('e1751326', __exports__)
  }
  
  module.hot.accept("./component-ge-expl-id-vg.vue?vue&type=template&id=e1751326", () => {
    api.rerender('e1751326', render)
  })

}


export default __exports__